import { Box, Heading, Image } from '@wix/design-system';
import React from 'react';
import { clsx } from 'clsx';
import Base44SocialProof from '../../assets/images/base44socialproof.png';
import s from './Base44SocialProofCard.scss';
import { useIsMobile } from '@wix/core-domain-search';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { Base44SocialProofMobileSvg } from './Base44SocialProofMobileSvg';
export const Base44SocialProofCard = () => {
  const isMobile = useIsMobile();
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    height: isMobile ? '400px' : '340px',
    width: "100%",
    direction: "vertical",
    overflow: "hidden",
    align: "center",
    boxSizing: "border-box",
    transform: "translateZ(0)",
    background: "linear-gradient(180deg, #CEE0E7 25.8%, #7CBFD5 77.39%, #FAF9F7 103.18%)",
    borderRadius: "12px"
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "100%",
    align: "center",
    verticalAlign: "middle",
    position: "fixed"
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "720px",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: clsx(s.socialProofTitle, isMobile && s.mobile)
  }, t('domains_search_gate.base44.gate.banner')))), isMobile ? /*#__PURE__*/React.createElement(Base44SocialProofMobileSvg, null) : /*#__PURE__*/React.createElement(Image, {
    src: Base44SocialProof,
    transparent: true,
    fit: "none",
    height: "340px"
  }));
};
//# sourceMappingURL=Base44SocialProofCard.js.map